module.exports = __webpack_public_path__ + "static/media/ckx_x.3108c4dc.jpg";